import { PAPER_ELEMENT_TYPE } from '../../../../shared/constants/drawable-types'
import store from '../../../../stores'
import { updateSelectedPaperId } from '../../../slices/2D'
import { setMasterSetPlanToCreate } from '../../../slices/masterSetPlan'
import { IMUP2DCoordinatesToUpdate } from '../../../types'

function saveNewMasterSetClassificationCoords(): (coordinatesToUpdate: IMUP2DCoordinatesToUpdate) => void {
    return function saveFn(this: paper.Path, coordinatesToUpdate) {
        store.dispatch(
            setMasterSetPlanToCreate([
                {
                    id: this.id,
                    coordinates: coordinatesToUpdate.coordinates,
                },
            ])
        )
    }
}

function selectNewMasterSetClassification(): () => void {
    return function selectFn(this: paper.Path) {
        store.dispatch(updateSelectedPaperId(this.id))
    }
}

function deselectNewMasterSetClassification(): () => void {
    return function deselectFn(this: paper.Path) {
        store.dispatch(updateSelectedPaperId(null))
    }
}

export default function addSelectFunctionalityToNewMasterSetClassificationPath(
    masterSetClassificationPath: paper.PathItem
): void {
    masterSetClassificationPath.data.type = PAPER_ELEMENT_TYPE.NEW_MASTER_SET_CLASSIFICATION
    masterSetClassificationPath.data.onSave = saveNewMasterSetClassificationCoords().bind(masterSetClassificationPath)
    masterSetClassificationPath.data.onSelect = selectNewMasterSetClassification().bind(masterSetClassificationPath)
    masterSetClassificationPath.data.onDeselect = deselectNewMasterSetClassification().bind(masterSetClassificationPath)
}
